import React, { useMemo, useState } from "react";
import { listOffers } from "./aiHireApi";
import CandidateDrawer from "./CandidateDrawer";
import { ChipGroup, EmptyRow, Tone, Toolbar, fmtCtc, fmtDate, useAiHireData } from "./AiHireUi";

const OFFER_STATUSES = ["Sent", "Viewed", "Accepted", "Declined", "Joined"];
const OFFER_TONE = { Sent: "blue", Viewed: "indigo", Accepted: "green", Declined: "red", Joined: "emerald" };

/** Offer Released: every offer sent, and where the candidate is with it. */
function OffersReleasedTab() {
  const offers = useAiHireData(listOffers, []);
  const [status, setStatus] = useState("");
  const [open, setOpen] = useState(null);

  const visible = useMemo(() => (offers || []).filter((o) => !status || o.status === status), [offers, status]);
  const options = [
    { id: "", label: "Released", count: offers?.length ?? 0 },
    ...OFFER_STATUSES.map((s) => ({ id: s, label: s, count: (offers || []).filter((o) => o.status === s).length })),
  ];

  return (
    <div className="aihire-tab">
      <Toolbar>
        <ChipGroup label="Status" options={options} value={status} onChange={setStatus} />
      </Toolbar>
      <div className="aihire-table-wrap">
        <table className="aihire-table">
          <thead>
            <tr>
              <th>Candidate</th>
              <th>Role</th>
              <th>Client / Project</th>
              <th className="num">CTC</th>
              <th>Offer date</th>
              <th>Valid till</th>
              <th>Joining</th>
              <th>Status</th>
              <th>Owner</th>
            </tr>
          </thead>
          <tbody>
            {offers && visible.length === 0 ? <EmptyRow colSpan={9}>No offers with this status.</EmptyRow> : null}
            {visible.map((o) => (
              <tr key={o.id}>
                <td>
                  <button type="button" className="aihire-link" onClick={() => setOpen(o.application)}>
                    {o.application.candidate.name}
                  </button>
                </td>
                <td>{o.application.job.title}</td>
                <td>
                  {o.application.job.client} / {o.application.job.project}
                </td>
                <td className="num">{fmtCtc(o.ctc)}</td>
                <td>{fmtDate(o.offerDate)}</td>
                <td>{fmtDate(o.validTill)}</td>
                <td>{fmtDate(o.joiningDate)}</td>
                <td>
                  <Tone tone={OFFER_TONE[o.status]}>{o.status}</Tone>
                  {o.note ? <div className="aihire-muted aihire-small">{o.note}</div> : null}
                </td>
                <td>{o.owner}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {open ? <CandidateDrawer app={open} onClose={() => setOpen(null)} /> : null}
    </div>
  );
}

export default OffersReleasedTab;
